import { createClient } from '@base44/sdk';
// import { getAccessToken } from '@base44/sdk/utils/auth-utils';

// Create a client with authentication required
export const base44 = createClient({
  appId: "6810d3cd511acf89df096abb", 
  requiresAuth: false // Ensure authentication is required for all operations
});
